import template from './raw-material-articles.html';
import controller from './raw-material-articles.controller';
import './raw-material-articles.scss';

let RawMaterialArticlesComponent = {
  bindings: {
    material: '<'
  },
  template,
  controller
};

export default RawMaterialArticlesComponent;



// WEBPACK FOOTER //
// ./src/app/pages/raw-material-articles/raw-material-articles.component.js